
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {UseState}       from "@Common/react/use-state";

import {isDevQuan}         from "../../../../../debug/is-dev-quan";
import {AltNameTypeConfig} from "../common/alt-name-type-config";
import {ConfirmCancel}     from "../common/confirm-cancel";
import {Header}            from "../common/header/header";
import {StepFinalize}      from "../common/step-finalize/step-finalize";

import {Step1Map}    from "./step-1-map/step-1-map";
import {Step1Search} from "./step-1-search/step-1-search";

export const Radius = ({onCancel, cancelLabel="Cancel", onClose, onCreated, entityId, next}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    ["step", (_, next) => UseState({
        initValue: 0,
        // ...isDevQuan() && {
        //     initValue: 1,
        // },
        next,
    })],
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["stepSearch", ({}, next) => Step1Search({
        entityId,
        next,
    })],
    ["stepMap", ({}, next) => Step1Map({next})],
    ["stepFinalize", ({}, next) => Step2Finalize({
        next,
    })],
    ({step, apis, confirmCancel, stepSearch, stepMap, stepFinalize, company}) => (
        step.value === 0 ? (
            company.prefs.enableMapBasedMailingSupport ? cs(
                keyed("map"),
                () => next({
                    onPassiveClose: stepMap.onPassiveClose,
                    content: stepMap.render({
                        onCancel,
                        cancelLabel,
                        onNext: () => step.onChange(1),
                    }),
                    width: 1200,
                    top: 10,
                    bottom: 10,
                })
            ) : cs(
                keyed(1),
                () => next({
                    onPassiveClose: stepSearch.onPassiveClose,
                    content: stepSearch.render({
                        onCancel,
                        cancelLabel,
                        onNext: () => step.onChange(1),
                    }),
                })
            )
        ) : cs(
            keyed(2),
            ({}) => next({
                onPassiveClose: confirmCancel,
                content: stepFinalize.render({
                    onBack: () => step.onChange(0),
                    getDefaultListName: () => (company.prefs.enableMapBasedMailingSupport ? stepMap : stepSearch).getDefaultListName(),
                    onComplete: async () => {
                        const requestData = await (company.prefs.enableMapBasedMailingSupport ? stepMap : stepSearch).createRequestData();
                        if (requestData.searchResult.streets?.result === "failed") {
                            alert("Failed to load addresses. Please try again.")
                        } else {
                            const result = await apis.next.mailing.createRadiusMailingList({
                                entityId,
                                info: stepFinalize.getRequestData(),
                                ...requestData,
                            });

                            // {"result":"failure","errors":{"target":"createRadiusList","msg":"Quantity is required"}}
                            if (result.result === "failure") {
                                alert(result.errors?.msg ?? "Unknown error");
                            } else {
                                onCreated([result.mailingListId]);

                                onClose();
                            }
                        }

                    },
                }),
            })
        )
    ),
);

const Step2Finalize = ({next}) => cs(
    ["altNameType", (_, next) => AltNameTypeConfig({next})],
    ["data", ({altNameType}, next) => UseState({
        initValue: {
            alternateName: {
                // type: "owner",
                type: altNameType,
            }
        },
        next,
    })],
    ({data}) => next({
        getRequestData: () => data.value,
        render: ({onBack, getDefaultListName, onComplete}) => StepFinalize({
            header: Header({
                icon: require("../../../mailing-icons/listtype-radius.png"),
                title: "Finalize Radius List",
                subTitle: "Name your list and approve to generate the order",
            }),
            name: "Radius",
            onBack,
            data,
            getDefaultListName,
            onComplete,
            xdQaName: "Finalize Radius List",
        }),
    }),
);
